import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FORMNAMES, setBrowserTitle } from "../utilities/codes";
import { getFormEntriesByFormName } from "../services/formServices";
import { schoolContext } from "../contexts/SchoolContextProvider"
import AboutSchool from "../components/AboutSchool";
import { useTranslation } from "react-i18next";
import { mediaSource } from "../utilities/mediautilities.js";
import { I18N_KEYS } from "../languages/PlaceHolder.js";
import Breadcrumb from "../components/Breadcrumb.jsx";
const About = () => {
    const { schoolDetails } = useContext(schoolContext);
    const [features, setFeatures] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        setBrowserTitle("About")
        getFeatures();
    }, []);

    const getFeatures = async () => {
        try {
            const response = await getFormEntriesByFormName(FORMNAMES.SCHOOLFEATURES);
            setFeatures(response);
        } catch (error) {
            toast.error(error.message);
        }
    }
    const featureVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, type: "spring", stiffness: 120 },
        }),
    };

    return (
        <>
            <section className="relative bg-cover bg-center py-36 px-6">
                <img
                    src={mediaSource(schoolDetails?.about_us?.fileUrl)}
                    alt={"Page banner"}
                    className="absolute inset-0 w-full h-full object-cover"
                />
            </section>
            <Breadcrumb />

            <AboutSchool />

            {features?.length > 0 &&
                <section className="bg-gray-100 py-20 px-6 overflow-hidden">
                    <div className="common-container">
                        <h2 className="text-4xl font-bold text-center text-primary mb-12">
                            {t(I18N_KEYS.FEATURETITLE)}
                        </h2>
                        <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    custom={index}
                                    variants={featureVariants}
                                    initial="hidden"
                                    whileInView="visible"
                                    whileHover={{ scale: 1.08 }}
                                    className="relative bg-gradient-to-tr from-accent to-gray-100 p-6 rounded-2xl shadow-lg cursor-pointer hover:shadow-2xl transition-transform duration-500 overflow-hidden"
                                >
                                    {(feature?.payload?.feature_title || feature?.payload?.description) &&
                                        <div className="mt-8">
                                            {feature?.payload?.feature_title &&
                                                <h3 className="text-xl font-bold text-primary mb-3">{feature?.payload?.feature_title}</h3>
                                            }
                                            {feature?.payload?.description &&
                                                <p className="text-gray-600"
                                                    dangerouslySetInnerHTML={{
                                                        __html: feature?.payload?.description
                                                    }}
                                                ></p>
                                            }
                                        </div>
                                    }

                                    <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-primary/10 blur-2xl"></div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </section>
            }


        </>
    );
}

export default About;